import { Component, OnInit, ViewChild, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { FileUploader } from 'ng2-file-upload';
import { every, filter } from 'lodash';
import { FacebookService } from '../../../services/facebook.service';
import { AppConfigService } from '../../../services/app-config.service';
import { ImagePreprocessingService } from '../../../+stories/new/image-preprocessing.service';
import { ImageFilteringService } from '../../../+stories/new/image-filtering.service';
import { Observable } from 'rxjs';
import { DetectPlatformService } from '../../../services/detectPlatform.service';
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { FileItem } from 'ng2-file-upload/ng2-file-upload';
import { UploadService } from './upload.service';
import { ContribService } from 'app/+projects/contrib/contrib.service';
import { CurrentUser } from 'app/services/currentUser.service';
import { ImageModel } from 'app/+stories/new/_models/image.model';

@Component({
  selector: 'contrib-uploader',
  styleUrls: ['./upload.component.scss', '../contribWizard.component.scss'],
  templateUrl: './upload.component.html',
})

export class UploadComponent implements OnInit, AfterViewInit {
  @ViewChild('fileInput', { static: false }) private fileInput;
  @Input() step;
  @Input() totalSteps;
  @Input() isMobile;
  @Input() owner;
  @Input() projectInfo;
  @Output() next = new EventEmitter();

  isSelectionModeShowing;
  isAssistantModalShowing = false;
  assistantModalShowed = false;
  displaySelectedPhotosConfirmationModal;
  uploading;
  uploader: any = new FileUploader({});
  hasBaseDropZoneOver = false;
  minPhotosCount;
  maxPhotosCount;
  showConfirmLeavePage;
  redirectUrl;
  storyCreationCancelled;
  user;
  isChecked = true;
  allSelected = true;

  load: boolean;
  public files: NgxFileDropEntry[] = [];

  processedImagesObservable: Observable<ImageModel[]>;
  processedImages: ImageModel[];

  oldUploaderQueueLength = 0;

  constructor(
    private router: Router,
    public uploadService: UploadService,
    public fb: FacebookService,
    private imagePreprocessingService: ImagePreprocessingService,
    private imageFilteringService: ImageFilteringService,
    private appConfigService: AppConfigService,
    public detectPlatformService: DetectPlatformService,
    private contribService: ContribService,
    private currentUser: CurrentUser,
    private activatedRoute: ActivatedRoute,
  ) {
    this.processedImagesObservable = this.imagePreprocessingService.images;
  }

  ngOnInit() {
    this.processedImagesObservable
    .subscribe(images => {
      this.processedImages = images;
    });
    window.scrollTo(0, 0);
    this.user = this.currentUser.getFirstName();
    this.minPhotosCount = 1;
    this.maxPhotosCount = this.appConfigService.config.max_upload_image_count;
    // this.firebaseService.logEvent('design_request_enter', {
    //   project_id: this.projectInfo.id,
    // });
    this.storyCreationCancelled = false;
    this.onDesignModeSubmit();
    this.owner = this.contribService.owner;
    this.uploadService.setProjectId(this.projectInfo.id);
  }

  ngAfterViewInit() {
    this.fileInput.nativeElement.click();
  }

  get isMobilePlatform() {
    return !!this.detectPlatformService.getPlatform();
  }

  onDesignModeSubmit() {
    this.isSelectionModeShowing = false;
    this.uploader.queue.forEach((photo: any) => {
      photo.unchecked = undefined;
    });
  }

  navigateBack() {
    if (this.uploader.queue.length) {
      this.showLeavePageModal();
    } else {
      this.router.navigate(['/projects/' +
      this.activatedRoute.snapshot.paramMap.get('uuid') + '/contribute'],
      {queryParams: {token: this.activatedRoute.snapshot.queryParamMap.get('token')}});
    }
  }

  showAssistantModal() {
    const displayModal =
      !this.assistantModalShowed && !this.isAutomaticDesignMode();
    if (displayModal) {
      this.isAssistantModalShowing = true;
    } else {
      this.fileInput.nativeElement.click();
    }
  }

  hideAssistantModal() {
    this.isAssistantModalShowing = false;
  }

  selectPhotos() {
    this.assistantModalShowed = true;
    this.hideAssistantModal();
    this.fileInput.nativeElement.click();
  }

  checkSelectionValue(event: any) {
    if (event) {
      this.isChecked = true;
      this.selectAll(true);
    } else {
      this.isChecked = false;
      this.selectAll(false);
    }
 }

  async onPhotoAdded() {
    this.uploader.queue = this.imageFilteringService.filter(
      this.uploader.queue
    );

    this.imagePreprocessingService.preprocess(this.uploader.queue.slice(this.oldUploaderQueueLength));
    this.oldUploaderQueueLength = this.uploader.queue.length;

    const imagesCountBeforeFiltering = this.uploader.queue.length;

    this.uploader.queue = this.imageFilteringService.filter(
      this.uploader.queue
    );
  }
  isUploadReady() {
    return (
      this.uploader.queue.length && !this.isUploadLess() && !this.isUploadMore()
      && this.selectedPhotosCount() >= this.minPhotosCount
    );
  }

  isUploadLess() {
    if (this.isAutomaticDesignMode()) {
      return (
        this.uploader &&
        this.uploader.queue &&
        this.selectedPhotosCount() > 0 &&
        this.selectedPhotosCount() < this.minPhotosCount
      );
    } else {
      return (
        this.uploader &&
        this.uploader.queue &&
        this.uploader.queue.length > 0 &&
        this.uploader.queue.length < this.minPhotosCount
      );
    }
  }

  isUploadMore() {
    if (this.isAutomaticDesignMode()) {
      return (
        this.uploader &&
        this.uploader.queue &&
        this.selectedPhotosCount() > this.maxPhotosCount
      );
    } else {
      return (
        this.uploader &&
        this.uploader.queue &&
        this.uploader.queue.length > this.maxPhotosCount
      );
    }
  }

  hideConfirmationModal() {
    this.displaySelectedPhotosConfirmationModal = false;
  }

  onPhotosSubmit() {
    if (this.isAutomaticDesignMode()) {
      this.displaySelectedPhotosConfirmationModal = true;
    } else {
      this.upload();
    }
  }

  upload() {
    window.scrollTo(0, 0);
    this.uploadService.images = this.processedImages;
    this.uploadService.startUpload();
    this.displaySelectedPhotosConfirmationModal = false;
    this.uploading = true;
    this.next.emit();
  }

  hasAlbums() {
    return this.uploadService.hasAlbums();
  }

  isAutomaticDesignMode() {
    return true;
  }

  removePhoto(index) {
    this.uploader.queue.splice(index, 1);
  }

  togglePhoto(photo) {
    photo.unchecked = !photo.unchecked;
  }

  selectedPhotosCount() {
    return filter(this.uploader.queue, this.isSelected).length;
  }

  isSelected(photo) {
    return !photo.unchecked;
  }

  // isAllSelected() {
  //   if (!this.isChecked) {
  //     return every(this.processedImages, this.isSelected);
  //   } else {
  //     this.allSelected = true;
  //     this.processedImages.forEach((photo: any) => {
  //       if (this.allSelected) {
  //         const item = photo.alias ? photo : photo.selectedPicture;
  //         if (!item.unchecked) {
  //           this.allSelected = true;
  //         } else {
  //           this.allSelected = false;
  //         }
  //       }
  //     });
  //     return this.allSelected;
  //   }

  // }

  selectAll(option) {
    if (option === true) {
      this.processedImages.forEach((photo: any) => {
        if (!photo.isDuplicate) {
          photo.unchecked = false;
        }
      });
    } else {
      this.processedImages.forEach((photo: any) => {
        photo.unchecked = true;
      });
    }
  }

  uploadHintKey() {
    return this.isAutomaticDesignMode()
      ? 'all_photos_will_be_used_contribute'
      : 'send_us_all_photos';
  }

  showLeavePageModal() {
    this.showConfirmLeavePage = true;
  }

  confirmLeavingPage() {
    this.showConfirmLeavePage = false;
    this.storyCreationCancelled = true;
    this.router.navigate(['/projects/' +
    this.activatedRoute.snapshot.paramMap.get('uuid') + '/contribute'],
    {queryParams: {token: this.activatedRoute.snapshot.queryParamMap.get('token')}});
  }

  stayOnPage() {
    this.redirectUrl = '';
    this.showConfirmLeavePage = false;
  }
  canDeactivate(nextState: RouterStateSnapshot): Observable<boolean> | boolean {
    if (
      nextState.url !== '/stories/upload_wizard' &&
      this.uploader.queue.length &&
      !this.storyCreationCancelled
    ) {
      this.showLeavePageModal();
      this.redirectUrl = nextState.url;
      return false;
    }
    return true;
  }

  public dropped(files: NgxFileDropEntry[]) {
    this.files = files;
    for (const droppedFile of files) {

      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {

          // Here you can access the real file
          const fileItem = new FileItem(this.uploader, file, {});
          this.uploader.queue.push(fileItem);
          this.onPhotoAdded();
          /**
          // You could upload it like this:
          const formData = new FormData()
          formData.append('logo', file, relativePath)

          // Headers
          const headers = new HttpHeaders({
            'security-token': 'mytoken'
          })

          this.http.post('https://mybackend.com/api/upload/sanitize-and-save-logo', formData, { headers: headers, responseType: 'blob' })
          .subscribe(data => {
            // Sanitized logo returned from backend
          })
          **/

        });
      } else {
        // It was a directory (empty directories are added, otherwise only files)
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
      }
    }
  }

  public fileOver(event) {
  }

  public fileLeave(event) {
  }
}
